import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { TargetingAsinStatsComponent } from "@m19-board/sponsored-product/sp-page/targeting-asin-stats/targeting-asin-stats.component";
import { AccountSelectionService } from "@front/m19-services";
import { toSignal } from "@angular/core/rxjs-interop";
import { CampaignType, StrategyType } from "@front/m19-api-client";
import { StrategyPageService } from "@m19-board/strategies/strategy-page/strategy-page.service";

@Component({
  selector: "app-strategy-page-targeting-stats",
  imports: [TargetingAsinStatsComponent],
  templateUrl: "./strategy-page-targeting-stats.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageTargetingStatsComponent {
  private readonly strategyPageService = inject(StrategyPageService);
  private readonly accountMarketplaceSelection = inject(AccountSelectionService);

  strategy = this.strategyPageService.strategy;

  isReadOnly = toSignal(this.accountMarketplaceSelection.readOnlyMode$, { requireSync: true });

  withTOSROSwitch = computed(() => {
    const isSubStrategy = this.strategy()?.strategyGroupId;
    return isSubStrategy
      ? this.strategy()?.strategyType === StrategyType.PRODUCT
      : this.strategy()?.campaignType === CampaignType.SP;
  });
}
